import styled from 'styled-components'
import { Modal } from 'antd'

export const MyModal = styled(Modal)<{
  dark?: boolean
  isFullScreen?: boolean
}>`
  .ant-modal-content {
    background: ${props =>
      props.dark ? props.theme['neutral-100'] : props.theme['neutral-800']};
  }
  .ant-modal-header {
    border-radius: 20px 20px 0 0;
    padding: ${props =>
      props.isFullScreen ? '24px 24px 0 24px' : '32px 32px 0 32px'};
    border: none;
    background: ${props =>
      props.dark ? props.theme['neutral-100'] : props.theme['neutral-800']};
  }
  .ant-modal-title {
    color: ${props =>
      props.dark ? props.theme['neutral-800'] : props.theme['neutral-200']};
    font-size: 32px;
    line-height: 40px;
  }
  .ant-modal-close {
    top: 32px;
    right: 32px;
    &:hover {
      .ant-modal-close-icon {
        color: ${props =>
          props.dark ? props.theme['neutral-500'] : props.theme['neutral-200']};
        border-color: ${props =>
          props.dark ? props.theme['neutral-500'] : props.theme['neutral-200']};
      }
    }
  }
  .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  .ant-modal-close-icon {
    transition: all 0.3s ease-in;
    border: 2px solid
      ${props =>
        props.dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
    border-radius: 48px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: ${props =>
      props.dark ? props.theme['neutral-400'] : props.theme['neutral-200']};
  }
  .ant-modal-body {
    padding: ${props => (props.isFullScreen ? '12px 24px 24px 24px' : '32px')};
  }
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-form-item-extra {
    margin-top: 12px;
  }
`
